export default "__VITE_ASSET__7972ebbc__"